import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ef24c86c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tier-local-table"
};
const _hoisted_2 = {
  class: "table-toolbar"
};
const _hoisted_3 = {
  class: "toolbar-left"
};
const _hoisted_4 = {
  class: "selected-count"
};
const _hoisted_5 = {
  class: "toolbar-right"
};
const _hoisted_6 = {
  class: "table-head"
};
const _hoisted_7 = {
  class: "col-check"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-country"
}, "国家/地区", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-tier"
}, "价格层级", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-price"
}, "本地价格", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-opt"
}, "操作", -1));
const _hoisted_12 = {
  class: "table-body"
};
const _hoisted_13 = {
  key: 1,
  class: "body-empty"
};
const _hoisted_14 = {
  key: 2
};
const _hoisted_15 = {
  class: "col-check"
};
const _hoisted_16 = {
  class: "col-country"
};
const _hoisted_17 = {
  class: "region-code"
};
const _hoisted_18 = {
  class: "col-tier"
};
const _hoisted_19 = {
  class: "price-currency"
};
const _hoisted_20 = {
  class: "col-opt"
};
import SvgIcon from '@/components/SvgIcon.vue';
import { DownOutlined } from '@ant-design/icons-vue';
import QuickImportModal from './QuickImportModal.vue';
import { generateTieredNativePrices } from '../services/tieredPricing';
import useDetailHooks from '../hooks/useDetailHooks';
import { getLadderPrice } from '@/api/goodsInfo';
export default /*#__PURE__*/_defineComponent({
  __name: 'TierLocalPriceTable',
  props: {
    pkg: {
      type: String,
      default: ''
    },
    prodChnl: {
      type: String,
      default: ''
    },
    prodType: {
      type: String,
      default: ''
    },
    prodPriceCurrency: {
      type: String,
      default: 'USD'
    },
    dbtId: {
      type: String,
      default: ''
    },
    // 有效层级（来自层级默认价组件），缺省给初始三级
    tierLevels: {
      type: Array,
      default: () => ['T1', 'T2', 'T3']
    },
    // GST 调价开启时把新加坡置顶
    pinSingapore: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      verifyNumber
    } = useDetailHooks();
    // change: 国家层级分配变化 → 通知父级防抖重新调接口①生成本地价
    const loading = ref(false);
    const searchName = ref('');
    const list = ref([]);
    const selectedCodes = ref(new Set());
    const quickImportOpen = ref(false);
    const isApple = computed(() => props.prodChnl === 'apple');
    const getNode = node => node.parentNode;
    // 模板映射：后端返回的「国家→层级」，记住后按当前有效层级渐进生效（仅赋已配置的层级，否则 T1 兜底）
    const templateTierByCode = ref(new Map());
    // 手动覆盖：用户手动改过层级的国家，优先于模板，刷新时不被模板覆盖（以手动为准）
    const manualTierByCode = ref(new Map());
    const markManual = (code, tierCode) => manualTierByCode.value.set(code, tierCode);
    // 当前已配置（有基准价）的有效层级集合
    const validTierSet = computed(() => new Set(props.tierLevels));
    // 解析某国应展示的层级：手动 > 模板(该层级须已配置) > T1 兜底
    // 层级默认价里选的锚点国不再特殊处理：未手动/未命中模板的国家统一默认 T1
    const resolveTier = code => {
      const manual = manualTierByCode.value.get(code);
      if (manual && validTierSet.value.has(manual)) return manual;
      const tpl = templateTierByCode.value.get(code);
      if (tpl && validTierSet.value.has(tpl)) return tpl;
      return 'T1';
    };
    // 新加坡：GST 调价开启时置顶展示；苹果返回 ISO3(SGP)、谷歌返回 ISO2(SG)，两者都兼容
    const SINGAPORE_CODES = new Set(['SGP', 'SG']);
    const tierOptions = computed(() => props.tierLevels.map(lv => ({
      label: lv,
      value: lv
    })));
    // 可批量操作的行：全部行均可勾选/批量改层级
    const selectableList = computed(() => filteredList.value);
    const filteredList = computed(() => {
      const key = searchName.value.trim().toLowerCase();
      const rows = key ? list.value.filter(row => row.regionName.toLowerCase().includes(key) || row.regionCode.toLowerCase().includes(key)) : list.value;
      // 置顶优先级：新加坡(1，仅 GST 调价开启) > 其余(0)；sort 稳定，同级保持原有顺序
      const rank = code => {
        if (props.pinSingapore && SINGAPORE_CODES.has(code)) return 1;
        return 0;
      };
      return [...rows].sort((a, b) => rank(b.regionCode) - rank(a.regionCode));
    });
    const allChecked = computed(() => selectableList.value.length > 0 && selectableList.value.every(row => selectedCodes.value.has(row.regionCode)));
    const indeterminate = computed(() => selectableList.value.some(row => selectedCodes.value.has(row.regionCode)) && !allChecked.value);
    // 当前国家→层级映射：仅下发用户分配到非 T1 层级的国家。
    // 后端对未显式映射的国家按 T1 兜底定价，故 T1 国家无需下发。
    const buildMappings = () => list.value.filter(row => row.tierCode && row.tierCode !== 'T1').map(row => ({
      regionCode: row.regionCode,
      tierCode: row.tierCode
    }));
    // 接口①：按层级基准价 + 当前国家层级映射批量生成各国本地价
    // 保留用户已分配的层级（层级是接口入参，非返回值）；手改价随重算被覆盖（与单一价格流一致）
    const generate = async (tierPrices, applySgtAdjustment) => {
      // T1 兜底层级未填基准价则不查全表（问题1）：清空表格、不调接口①
      const t1 = tierPrices.find(t => t.tierCode === 'T1');
      if (!props.pkg || !t1 || !t1.prodPrice) {
        list.value = [];
        selectedCodes.value = new Set();
        return;
      }
      // 按「手动/模板/有效层级」解析当前国家全集的目标层级，据此组装发给后端的映射，
      // 保证后端按各国正确层级计算价格。对齐规则：
      // 1) 只下发非 T1、且该层级已配基准价的项（避免层级与国家不匹配后端报错）
      // 2) 层级基准价只下发「至少有一个国家归属」的层级（T1 始终下发）
      const pricedTiers = new Set(tierPrices.map(t => t.tierCode));
      const safeMappings = list.value.map(row => ({
        regionCode: row.regionCode,
        tierCode: resolveTier(row.regionCode)
      })).filter(m => m.tierCode !== 'T1' && pricedTiers.has(m.tierCode));
      const usedTiers = new Set(safeMappings.map(m => m.tierCode));
      usedTiers.add('T1');
      const effectiveTierPrices = tierPrices.filter(t => usedTiers.has(t.tierCode));
      loading.value = true;
      try {
        const prices = await generateTieredNativePrices({
          dbtId: props.dbtId,
          pkg: props.pkg,
          prodChnl: props.prodChnl,
          prodType: props.prodType,
          tierPrices: effectiveTierPrices,
          countryTierMappings: safeMappings,
          applySgtAdjustment
        });
        // 各国层级按 resolveTier 解析：手动改过的保留手动；其余按模板(已配置层级)，缺省 T1
        list.value = prices.map(item => {
          var _item$originProdPrice;
          return {
            regionCode: item.regionCode,
            regionName: item.regionName,
            prodPriceCurrency: item.prodPriceCurrency,
            prodPrice: item.prodPrice,
            originProdPrice: (_item$originProdPrice = item.originProdPrice) !== null && _item$originProdPrice !== void 0 ? _item$originProdPrice : item.prodPrice,
            tierCode: resolveTier(item.regionCode),
            editMode: false
          };
        });
        selectedCodes.value = new Set();
      } finally {
        loading.value = false;
      }
    };
    const onToggleRow = code => {
      const next = new Set(selectedCodes.value);
      next.has(code) ? next.delete(code) : next.add(code);
      selectedCodes.value = next;
    };
    const onCheckAll = e => {
      const next = new Set(selectedCodes.value);
      selectableList.value.forEach(row => {
        e.target.checked ? next.add(row.regionCode) : next.delete(row.regionCode);
      });
      selectedCodes.value = next;
    };
    // 单行层级变更 → 记为手动覆盖（后续模板刷新不再改它）并通知父级重算
    const onRowTierChange = row => {
      markManual(row.regionCode, row.tierCode);
      emit('change');
    };
    // 批量设置层级：对选中国家应用，记为手动覆盖；生效后清空勾选并通知重算
    const onBatchSetTier = ({
      key
    }) => {
      list.value.forEach(row => {
        if (selectedCodes.value.has(row.regionCode)) {
          row.tierCode = key;
          markManual(row.regionCode, key);
        }
      });
      selectedCodes.value = new Set();
      emit('change');
    };
    // 进入改价：苹果懒加载该国阶梯价作为下拉选项（与单一模式 PriceBlock2 一致），命中缓存则不重复拉
    const onStartEdit = async row => {
      // 快照当前价（可能是系统原价，也可能是上一次确认后的值），取消时还原到此
      row.editBackup = row.prodPrice;
      row.editMode = true;
      if (!isApple.value || row.priceOptions && row.priceOptions.length) return;
      row.priceLoading = true;
      try {
        const res = await getLadderPrice({
          dbtId: props.dbtId,
          regionCode: row.regionCode,
          prodType: props.prodType
        });
        row.priceOptions = res.code === '0' ? res.data : [];
      } finally {
        row.priceLoading = false;
      }
    };
    // 单行改价确认：苹果走阶梯价下拉（值天然合法）；谷歌等自由输入仍 verifyNumber 校验
    const onConfirmEdit = async row => {
      if (isApple.value) {
        row.editMode = false;
        return;
      }
      const flag = await verifyNumber({
        prodChnl: props.prodChnl,
        prodPrice: row.prodPrice,
        prodPriceCurrency: row.prodPriceCurrency,
        regionCode: row.regionCode,
        prodType: props.prodType
      });
      if (!flag) {
        row.prodPrice = row.originProdPrice;
      } else {
        row.prodPrice = parseFloat(row.prodPrice).toFixed(2);
      }
      row.editMode = false;
    };
    // 取消手改：还原到进入编辑前的值（上一次确认价或系统原价），而非永远回退系统原价
    const onCancelEdit = row => {
      var _row$editBackup;
      row.prodPrice = (_row$editBackup = row.editBackup) !== null && _row$editBackup !== void 0 ? _row$editBackup : row.originProdPrice;
      row.editMode = false;
    };
    // 快捷录入写回：仅更新本次录入命中的国家层级（记为手动覆盖），保留其余已设层级（不重置为 T1）
    const onQuickImportConfirm = payload => {
      if (payload.mode === 'single') {
        const codeSet = new Set(payload.codes);
        list.value.forEach(row => {
          if (codeSet.has(row.regionCode)) {
            row.tierCode = payload.tierCode;
            markManual(row.regionCode, payload.tierCode);
          }
        });
      } else {
        const tierByCode = new Map(payload.pairs.map(p => [p.regionCode, p.tierCode]));
        list.value.forEach(row => {
          const code = tierByCode.get(row.regionCode);
          if (code) {
            row.tierCode = code;
            markManual(row.regionCode, code);
          }
        });
      }
      emit('change');
    };
    const reset = () => {
      list.value = [];
      selectedCodes.value = new Set();
      searchName.value = '';
      // 清空映射缓存，避免连续创建时上一个商品的手动/模板层级残留
      manualTierByCode.value = new Map();
      templateTierByCode.value = new Map();
    };
    // 导出当前国家-层级映射（接口①生成 / 空置层级校验用）：不含 T1（后端兜底）
    const getCountryTierMappings = () => buildMappings();
    // 某层级是否有国家归属：当前行 ∪ 模板 ∪ 手动潜在映射（该层级一旦有效，这些国家会经 resolveTier 切过去）。
    // 供父级判断「改基准价 / 增删层级」是否需重算——无国家归属的层级变动不影响接口输出，可跳过接口①。
    const hasCountriesInTier = tierCode => {
      if (list.value.some(row => row.tierCode === tierCode)) return true;
      for (const v of manualTierByCode.value.values()) if (v === tierCode) return true;
      for (const v of templateTierByCode.value.values()) if (v === tierCode) return true;
      return false;
    };
    // 保存专用国家-层级映射：含 T1 国家（后端需显式落库）
    const getCountryTierMappingsForSave = () => list.value.filter(row => row.tierCode).map(row => ({
      regionCode: row.regionCode,
      tierCode: row.tierCode
    }));
    // 导出最终本地价列表（保存时作为 productNativePrice 下发）
    const getNativePrices = () => list.value.map(row => ({
      regionCode: row.regionCode,
      regionName: row.regionName,
      prodPriceCurrency: row.prodPriceCurrency,
      prodPrice: row.prodPrice,
      originProdPrice: row.originProdPrice
    }));
    // 记住后端模板映射（不直接改表）：每次 generate 时按当前有效层级 + 手动覆盖经 resolveTier 渐进生效
    const applyTemplateMappings = mappings => {
      templateTierByCode.value = new Map((mappings || []).map(m => [m.regionCode, m.tierCode]));
    };
    // 编辑回显：直接用已保存的最终价 + 层级映射铺表（不调接口①）。
    // 已保存层级视为权威，存入手动覆盖，避免编辑态改价重算时被重置；同时清空模板（编辑不套模板）
    const initFromSaved = (prices, mappings) => {
      const tierByCode = new Map(mappings.map(m => [m.regionCode, m.tierCode]));
      manualTierByCode.value = new Map(tierByCode);
      templateTierByCode.value = new Map();
      list.value = (prices || []).map(item => {
        var _item$originProdPrice2;
        return {
          regionCode: item.regionCode,
          regionName: item.regionName,
          prodPriceCurrency: item.prodPriceCurrency,
          prodPrice: item.prodPrice,
          originProdPrice: (_item$originProdPrice2 = item.originProdPrice) !== null && _item$originProdPrice2 !== void 0 ? _item$originProdPrice2 : item.prodPrice,
          tierCode: tierByCode.get(item.regionCode) || 'T1',
          editMode: false
        };
      });
      selectedCodes.value = new Set();
    };
    expose({
      list,
      generate,
      reset,
      getCountryTierMappings,
      getCountryTierMappingsForSave,
      getNativePrices,
      applyTemplateMappings,
      initFromSaved,
      hasCountriesInTier
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input_number = _resolveComponent("a-input-number");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, "已选 " + _toDisplayString(selectedCodes.value.size) + " 项", 1), _createVNode(_component_a_dropdown, {
        disabled: __props.disabled || selectedCodes.value.size === 0,
        trigger: ['click']
      }, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, {
          onClick: onBatchSetTier
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tierLevels, lv => {
            return _openBlock(), _createBlock(_component_a_menu_item, {
              key: lv
            }, {
              default: _withCtx(() => [_createTextVNode("设为 " + _toDisplayString(lv), 1)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_a_button, {
          size: "small",
          class: "batch-btn"
        }, {
          default: _withCtx(() => [_createTextVNode(" 批量设置层级… "), _createVNode(_unref(DownOutlined))]),
          _: 1
        })]),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_button, {
        size: "small",
        class: "quick-btn",
        disabled: __props.disabled,
        onClick: _cache[0] || (_cache[0] = $event => quickImportOpen.value = true)
      }, {
        default: _withCtx(() => [_createTextVNode(" 快捷录入 ")]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_input, {
        class: "search-input",
        value: searchName.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => searchName.value = $event),
        size: "small",
        "allow-clear": "",
        placeholder: "搜索国家…"
      }, {
        prefix: _withCtx(() => [_createVNode(SvgIcon, {
          "icon-class": "search"
        })]),
        _: 1
      }, 8, ["value"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_createVNode(_component_a_checkbox, {
        checked: _unref(allChecked),
        indeterminate: _unref(indeterminate),
        disabled: __props.disabled || !_unref(filteredList).length,
        onChange: onCheckAll
      }, null, 8, ["checked", "indeterminate", "disabled"])]), _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11]), _createElementVNode("div", _hoisted_12, [loading.value ? (_openBlock(), _createBlock(_component_a_spin, {
        key: 0,
        class: "body-spin",
        tip: "加载中..."
      })) : !_unref(filteredList).length ? (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无数据")) : (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredList), row => {
        return _openBlock(), _createElementBlock("div", {
          key: row.regionCode,
          class: "table-row"
        }, [_createElementVNode("span", _hoisted_15, [_createVNode(_component_a_checkbox, {
          checked: selectedCodes.value.has(row.regionCode),
          disabled: __props.disabled,
          onChange: () => onToggleRow(row.regionCode)
        }, null, 8, ["checked", "disabled", "onChange"])]), _createElementVNode("span", _hoisted_16, [_createTextVNode(_toDisplayString(row.regionName) + " ", 1), _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(row.regionCode) + ")", 1)]), _createElementVNode("span", _hoisted_18, [_createVNode(_component_a_select, {
          value: row.tierCode,
          "onUpdate:value": $event => row.tierCode = $event,
          size: "small",
          style: {
            "width": "72px"
          },
          disabled: __props.disabled,
          options: _unref(tierOptions),
          getPopupContainer: getNode,
          onChange: () => onRowTierChange(row)
        }, null, 8, ["value", "onUpdate:value", "disabled", "options", "onChange"])]), _createElementVNode("span", {
          class: _normalizeClass(['col-price', {
            editLine: row.prodPrice !== row.originProdPrice
          }])
        }, [!row.editMode ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(row.prodPriceCurrency) + " " + _toDisplayString(row.prodPrice), 1)], 64)) : _unref(isApple) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("span", _hoisted_19, _toDisplayString(row.prodPriceCurrency), 1), _createVNode(_component_a_select, {
          size: "small",
          style: {
            "width": "100px"
          },
          value: row.prodPrice,
          "onUpdate:value": $event => row.prodPrice = $event,
          "show-search": "",
          loading: row.priceLoading,
          options: row.priceOptions,
          "field-names": {
            label: 'prodPrice',
            value: 'prodPrice'
          },
          getPopupContainer: getNode
        }, null, 8, ["value", "onUpdate:value", "loading", "options"])], 64)) : (_openBlock(), _createBlock(_component_a_input_number, {
          key: 2,
          size: "small",
          style: {
            "width": "110px"
          },
          value: row.prodPrice,
          "onUpdate:value": $event => row.prodPrice = $event,
          min: 0,
          controls: false,
          precision: 2,
          step: 0.01,
          "string-mode": "",
          "addon-after": row.prodPriceCurrency
        }, null, 8, ["value", "onUpdate:value", "step", "addon-after"]))], 2), _createElementVNode("span", _hoisted_20, [!__props.disabled ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!row.editMode ? (_openBlock(), _createBlock(SvgIcon, {
          key: 0,
          class: "opt-icon",
          "icon-class": "edit",
          onClick: $event => onStartEdit(row)
        }, null, 8, ["onClick"])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(SvgIcon, {
          class: "opt-icon",
          "icon-class": "confirm",
          onClick: $event => onConfirmEdit(row)
        }, null, 8, ["onClick"]), _createVNode(SvgIcon, {
          class: "opt-icon close",
          "icon-class": "close",
          onClick: $event => onCancelEdit(row)
        }, null, 8, ["onClick"])], 64))], 64)) : _createCommentVNode("", true)])]);
      }), 128))]))]), _createVNode(QuickImportModal, {
        open: quickImportOpen.value,
        "onUpdate:open": _cache[2] || (_cache[2] = $event => quickImportOpen.value = $event),
        "prod-chnl": __props.prodChnl,
        "tier-options": _unref(tierOptions),
        countries: list.value,
        onConfirm: onQuickImportConfirm
      }, null, 8, ["open", "prod-chnl", "tier-options", "countries"])]);
    };
  }
});